import React from 'react'
import PropTypes from 'prop-types'
import { MiSC } from '../../SVG'
import abbreviate from 'number-abbreviate'

class Designation extends React.Component {
  isSelected = () => {
    return this.props.status === 'selected'
  }

  isDisabled = () => {
    return this.props.status === 'disabled'
  }

  isActive = () => {
    return this.props.status === 'active'
  }

  displayName = () => {
    const { name } = this.props.designation

    if (name.startsWith('MiSC')) {
      return (
        <>
          <MiSC status={this.props.status} /> {name.replace('MiSC', '')}
        </>
      )
    } else {
      return name
    }
  }

  renderTooltip = (title) => {
    return (
      <i
        className='fal fa-question-circle filter-tooltip'
        data-tooltip
        data-allow-html='true'
        title={title}
        data-position='top'
        data-alignment='center'
        tabIndex='2'
      />
    )
  }

  displayTooltip = () => {
    switch (this.props.designation.name) {
      case 'MiSC Registered':
        return this.renderTooltip(
          'Discover suppliers registered for the Michigan Supplier Community (MiSC) program by using this filter. Learn more about how the MiSC program simplifies the bidding process for State of Michigan agencies <a href=\'https://www.michigan.gov/dtmb/0,5552,7-358-82550_85746_48677_92322---,00.html\' target=\'_blank\'>here</a>.'
        )
      case 'MiSC Eligible':
        return this.renderTooltip(
          'Discover suppliers that are eligible, but not yet registered, for the Michigan Supplier Community (MiSC) program by using this filter. Learn more about how the MiSC program simplifies the bidding process for State of Michigan agencies <a href=\'https://www.michigan.gov/dtmb/0,5552,7-358-82550_85746_48677_92322---,00.html\' target=\'_blank\'>here</a>.'
        )
      case 'TX HUB Certified':
        return this.renderTooltip(
          'Discover certified Texas HUB suppliers using this filter. Learn more about this program <a href=\'https://comptroller.texas.gov/purchasing/vendor/hub/#skip-scroll\' target=\'_blank\'>here</a>.'
        )
      default:
        return ''
    }
  }

  renderCheckBox = () => {
    if (this.isActive() || this.isDisabled()) {
      return (
        <i className='fal fa-square checkbox' />
      )
    } else {
      return (
        <i className='fad fa-check-square checkbox' />
      )
    }
  }

  render () {
    const { id, name } = this.props.designation

    return (
      <div
        key={id}
        className={`${this.props.status} grid-x filter ${this.isDisabled() ? 'pointer-default' : ''}`}
        onClick={() => {
          if (!this.isDisabled()) this.props.onDesignationChange(name)
        }}
      >
        <div className='shrink cell'>
          {this.renderCheckBox()}
        </div>
        <div className='auto cell designation-name'>
          {this.displayName()}
          {this.displayTooltip()}
        </div>
        <div className='shrink cell count'>
          {abbreviate(this.props.count, 1)}
        </div>
      </div>
    )
  }
}

Designation.propTypes = {
  designation: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  onDesignationChange: PropTypes.func.isRequired
}

export default Designation
